import { Box, BoxProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect } from 'react';
import { AepsButton } from '../../../comps/AepsButton'
import { Container } from '../../../comps/Container'
import { useStores } from '../../../data/store'
import { Screens } from '../../../nav/Screens'
import { formatDateWithTime, getFormattedAmount } from '../../../util/utill'
import { NamedValue, voucherStatusColors } from '../RefundDetails/RefundDetailComponent'
import { REFUND_STRINGS } from '../RefundStrings'

export const UtrRefundDetailScreen = () => {
  const navigation = useNavigation()
  const { utrRefRefundDetails } = useStores((root) => ({
    utrRefRefundDetails: root.reGenerateRefundCode.utrRefRefundDetails,
  }))

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Re-Generate Refund Code' })
  }, [navigation])

  return (
    <Container type="refund" title="Re-Generate Refund Code" showFooter={true}>
      <Box {...styles.renderedItem}>
        <NamedValue title={REFUND_STRINGS.utrRefCode} value={utrRefRefundDetails.utr} />
        <NamedValue title={'Date & Time'} value={formatDateWithTime(utrRefRefundDetails.transactionDate)} />
        <NamedValue title={'Product Type'} value={'Domestic Remittance'} />
        <NamedValue title={REFUND_STRINGS.Amount} value={getFormattedAmount(utrRefRefundDetails.voucherAmount)} />
        <NamedValue
          title={REFUND_STRINGS.voucherStatus}
          value={utrRefRefundDetails.voucherStatus}
          valueColor={voucherStatusColors[utrRefRefundDetails.voucherStatus]}
        />
      </Box>
      {utrRefRefundDetails.voucherStatus === 'ACTIVE' && (
        <AepsButton
          title={'Validate Customer'}
          onPress={() => {
            navigation.navigate(Screens.UTR_REF_CUSTOMER_VALIDATION_SCREEN as never)
          }}
          disabled={false}
          borderRadius={26}
        />
      )}
    </Container>
  )
}

const styles = {
  renderedItem: {
    flexDirection: 'row',
    width: '100%',
    justify: 'space-between',
    flexWrap: 'wrap',
    marginTop: 32,
    marginBottom: 16,
  } as BoxProps,
}
